import type { TFunction } from 'i18next';
import { formatDateTime, relativeSlot } from '@/shared/utils/datetime';

/**
 * 相对时间——浮层与通知列表**共用的一份**（2026-10-24 统一）：
 * 两个消费面（`features/events/SseToasts` / `features/notifications/NotificationList`）
 * 之前各写了一份同样的分支链 ⇒ 收进域层一处。
 *
 * - 档位与文案键：`notifications.relative.*`（刚刚 / N 分钟前 / N 小时前 / N 天前）；
 * - 超 7 天（或时间戳坏了）⇒ 相对档位没有意义 ⇒ 落**绝对时间**。
 */
export function relativeWhen(iso: string | null, t: TFunction): string | null {
  if (iso === null) return null;
  const slot = relativeSlot(iso);
  if (slot === null) return formatDateTime(iso);
  if (slot.key === 'now') return t('notifications.relative.now');
  if (slot.key === 'minutes') return t('notifications.relative.minutes', { count: slot.count });
  if (slot.key === 'hours') return t('notifications.relative.hours', { count: slot.count });
  return t('notifications.relative.days', { count: slot.count });
}
